import { TriangleAlert } from 'lucide-react';
import moment from 'moment-timezone';
import PropTypes from 'prop-types';
import React from 'react';

import styles from './DecisionStamp.module.scss';

export const stampText = ({ where, by, at }) =>
  [where, by, at ? moment.tz(at, moment.tz.guess()).format('h:mm A z') : null]
    .filter(Boolean)
    .join(' · ');

export const DecisionBadge = ({ tone = 'neutral', withIcon = false, children }) => (
  <span className={`${styles.badge} ${styles[tone]}`}>
    {withIcon && <TriangleAlert size={11} aria-hidden="true" />}
    {children}
  </span>
);

DecisionBadge.propTypes = {
  tone: PropTypes.oneOf(['neutral', 'outline', 'success', 'warning', 'danger', 'info']),
  withIcon: PropTypes.bool,
  children: PropTypes.node.isRequired,
};

const DecisionStamp = ({
  label,
  tone = 'neutral',
  withIcon = false,
  note,
  stamp,
  onUndo,
  undoLabel = 'Undo',
  disabled = false,
}) => (
  <div className={styles.stamp}>
    <DecisionBadge tone={tone} withIcon={withIcon}>
      {label}
    </DecisionBadge>
    {note && <span className={styles.note}>“{note}”</span>}
    {stamp && <span className={styles.when}>{stamp}</span>}
    {onUndo && (
      <button type="button" className={styles.undo} disabled={disabled} onClick={onUndo}>
        {undoLabel}
      </button>
    )}
  </div>
);

DecisionStamp.propTypes = {
  label: PropTypes.node.isRequired,
  tone: PropTypes.oneOf(['neutral', 'outline', 'success', 'warning', 'danger', 'info']),
  withIcon: PropTypes.bool,
  note: PropTypes.string,
  stamp: PropTypes.string,
  onUndo: PropTypes.func,
  undoLabel: PropTypes.string,
  disabled: PropTypes.bool,
};

export default DecisionStamp;
